'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'toolbar-menu',
  _template: html`
  <style include="paper-material-styles">
    :host {
        display: block;
        --paper-tab-ink: var(--paper-blue-grey-100);
    }

    paper-tabs {
        --paper-tabs-selection-bar-color: var(--paper-blue-grey-100);
    }

    paper-tab {
        text-transform: uppercase;
    }
  </style>
  <dom-module id="toolbar-menu">
    <link rel="stylesheet" href="toolbar-menu.css" />
      <link rel="import" href="../paper-tabs/paper-tabs.html">
      <template>
        <paper-tabs selected="[[selected]]" attr-for-selected="data-page" id="nav-tabs">
            <template is="dom-repeat" items="{{menuContent}}">
            <paper-tab data-page="{{item.page}}">{{item.text}}</paper-tab>
            </template>
        </paper-tabs>
    </template>

    <script src="toolbar-menu.js"></script>
  </dom-module>
    `,
  hostAttributes: {
    'menuContent': {
      type: Array,
      value: []
    }
  },
  properties: {
    selected: {
      value: 'songs'
    }
  }
})